import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { CartItem } from '../model/cart.model';
import { PriceChannel } from '../model/price-channel.model';

const minimumQuantity = 1;
const maximumQuantity = 9999;
const maximumQuantityPrivate = 9999;
const maximumQuantityPublic = 9999999;
const influenzaMaxQuantity = 99999;
const base = 10;
const one = 1;
const two = 2;
let minQuantityforInfluenza = 0;
const DISABLED_IMG_SELECTOR = 'disable-action';
const DISABLED_SELECTOR = 'disabled';

export class ProductUtils {
  static alterQuantity(operator, idData, quantityOfUnits): any {
    if (isNaN(quantityOfUnits)) {
      return;
    }

    const inputElement = document.getElementById(
      `prodQuantity${idData}`
    ) as HTMLInputElement;
    const minusIcon = document.getElementById(`minusIcon${idData}`);
    const plusIcon = document.getElementById(`plusIcon${idData}`);
    const noOfDoses =
      document.getElementById(`noOfDoses${idData}`) || ({} as HTMLInputElement);

    const unitMinus = document.getElementById(`unitMinus${idData}`);
    const unitMinusDisable = document.getElementById(
      `unitMinusDisable${idData}`
    );
    const unitPlus = document.getElementById(`unitPlus${idData}`);
    const unitPlusDisable = document.getElementById(`unitPlusDisable${idData}`);

    ProductUtils.attachInputChangeListeners();

    let orderValue = parseInt(inputElement.value, base);
    const regex = new RegExp('^[0-9]{1,4}$', 'g');

    if (regex.test(inputElement.value) === true) {
      orderValue = ProductUtils.calculateOrderValue(
        operator,
        orderValue,
        inputElement.value
      );
      ProductUtils.updateIcons(
        orderValue,
        minusIcon,
        plusIcon,
        unitMinus,
        unitMinusDisable,
        unitPlus,
        unitPlusDisable
      );
      ProductUtils.updateDoseDisplay(
        inputElement,
        noOfDoses,
        orderValue,
        quantityOfUnits
      );
    } else {
      if (orderValue > maximumQuantity) {
        orderValue = maximumQuantity;
        inputElement.value = maximumQuantity.toString();
        plusIcon?.classList.add('disabled');
        unitPlus?.classList.add('disabled-img');
        unitPlusDisable?.classList.remove('disabled-img');
        noOfDoses.innerHTML = `${orderValue * quantityOfUnits}  Doses`;
      } else {
        noOfDoses.innerHTML = `${quantityOfUnits}  Doses`;
        if (!orderValue) {
          minusIcon?.classList.add('disabled');
          unitMinus?.classList.add('disabled-img');
          unitMinusDisable?.classList.remove('disabled-img');
          plusIcon?.classList.remove('disabled');
          unitPlus?.classList.remove('disabled-img');
          unitPlusDisable?.classList.add('disabled-img');
        }
      }
    }
  }

  private static attachInputChangeListeners() {
    const numInputs = document.querySelectorAll('input[type=number]');
    numInputs.forEach(function (input) {
      input.addEventListener('change', function (e) {
        if ((e.target as HTMLInputElement).value === '') {
          (e.target as HTMLInputElement).value = '1';
        }
      });
    });
  }

  private static calculateOrderValue(
    operator: number,
    orderValue: number,
    inputValue: string
  ): number {
    if (operator === one) {
      return orderValue + 1;
    } else if (operator === two) {
      return orderValue - 1;
    } else {
      return parseInt(inputValue, base);
    }
  }

  private static updateIcons(
    orderValue: number,
    minusIcon: HTMLElement | null,
    plusIcon: HTMLElement | null,
    unitMinus: HTMLElement | null,
    unitMinusDisable: HTMLElement | null,
    unitPlus: HTMLElement | null,
    unitPlusDisable: HTMLElement | null
  ) {
    if (orderValue <= minimumQuantity) {
      minusIcon?.classList.add('disabled');
      unitMinus?.classList.add('disabled-img');
      unitMinusDisable?.classList.remove('disabled-img');
      plusIcon?.classList.remove('disabled');
      unitPlus?.classList.remove('disabled-img');
      unitPlusDisable?.classList.add('disabled-img');
    } else if (orderValue >= maximumQuantity) {
      minusIcon?.classList.remove('disabled');
      unitMinus?.classList.remove('disabled-img');
      unitMinusDisable?.classList.add('disabled-img');
      plusIcon?.classList.add('disabled');
      unitPlus?.classList.add('disabled-img');
      unitPlusDisable?.classList.remove('disabled-img');
    } else {
      minusIcon?.classList.remove('disabled');
      plusIcon?.classList.remove('disabled');
      unitPlus?.classList.remove('disabled-img');
      unitMinus?.classList.remove('disabled-img');
      unitPlusDisable?.classList.add('disabled-img');
      unitMinusDisable?.classList.add('disabled-img');
    }
  }

  private static updateDoseDisplay(
    inputElement: HTMLInputElement,
    noOfDoses: HTMLElement,
    orderValue: number,
    quantityOfUnits: number
  ) {
    if (inputElement.value !== '') {
      inputElement.value = orderValue.toString();
      noOfDoses.innerHTML = `${orderValue * quantityOfUnits}  Doses`;
    } else {
      noOfDoses.innerHTML = `${quantityOfUnits}  Doses`;
    }
  }

  // Custom-Prpduct Refinement Category Formatting
  static categoryFormatting(data): any {
    const value = [];
    if (data.id === one || data.id === one.toString()) {
      value.push({ name: 'All', value: data.url });
    }
    data.subcategories.forEach((obj) => {
      value.push({ name: obj.name, value: obj.url });
    });
    return value;
  }
  static alterQuantityforInfluenza(
    operator,
    idData,
    page,
    quantityOfUnits = 0
  ): any {
    minQuantityforInfluenza = page === 'cart' ? 1 : 0;

    const inputElement = document.getElementById(
      `prodQuantity${idData}`
    ) as HTMLInputElement;
    const minusIcon = document.getElementById(`minusIcon${idData}`);
    const plusIcon = document.getElementById(`plusIcon${idData}`);
    const noOfDoses = document.getElementById(
      `noOfDoses${idData}`
    ) as HTMLInputElement;
    const unitMinus = document.getElementById(`unitMinus${idData}`);
    const unitMinusDisable = document.getElementById(
      `unitMinusDisable${idData}`
    );
    const unitPlus = document.getElementById(`unitPlus${idData}`);
    const unitPlusDisable = document.getElementById(`unitPlusDisable${idData}`);

    ProductUtils.attachInputChangeListeners();

    let orderValue = parseInt(inputElement?.value, base);
    const regex = /^\d{1,5}$/g;

    if (ProductUtils.isValidInput(inputElement?.value, regex)) {
      orderValue = ProductUtils.calculateOrderValueForInfluenza(
        operator,
        orderValue,
        inputElement?.value
      );
      orderValue = ProductUtils.handleMinOrderValue(
        orderValue,
        minusIcon,
        unitMinus,
        unitMinusDisable,
        plusIcon,
        unitPlus,
        unitPlusDisable
      );
      orderValue = ProductUtils.handleMaxOrderValue(
        orderValue,
        minusIcon,
        unitMinus,
        unitMinusDisable,
        plusIcon,
        unitPlus,
        unitPlusDisable
      );
      ProductUtils.handleNormalOrderValue(
        orderValue,
        minusIcon,
        plusIcon,
        unitMinus,
        unitPlus,
        unitMinusDisable,
        unitPlusDisable
      );

      if (page === 'cart' && orderValue < 1) {
        orderValue = 1;
      }

      ProductUtils.updateDoseDisplayForInfluenza(
        inputElement,
        noOfDoses,
        orderValue,
        quantityOfUnits
      );
    } else {
      ProductUtils.handleInvalidInput(
        orderValue,
        {
          inputElement,
          plusIcon,
          unitPlus,
          unitPlusDisable,
          minusIcon,
          unitMinus,
          unitMinusDisable,
          noOfDoses,
        },
        quantityOfUnits
      );
    }
  }

  private static isValidInput(value: string, regex: RegExp): boolean {
    return regex.test(value);
  }

  private static calculateOrderValueForInfluenza(
    operator: number,
    orderValue: number,
    inputValue: string
  ): number {
    if (operator === one) {
      return orderValue + 1;
    } else if (operator === two && orderValue !== 0) {
      return orderValue - 1;
    } else {
      return parseInt(inputValue, base);
    }
  }

  private static handleMinOrderValue(
    orderValue: number,
    minusIcon: HTMLElement,
    unitMinus: HTMLElement,
    unitMinusDisable: HTMLElement,
    plusIcon: HTMLElement,
    unitPlus: HTMLElement,
    unitPlusDisable: HTMLElement
  ): number {
    if (orderValue <= minQuantityforInfluenza) {
      minusIcon.classList.add(DISABLED_SELECTOR);
      unitMinus.classList.add(DISABLED_IMG_SELECTOR);
      unitMinusDisable.classList.remove(DISABLED_IMG_SELECTOR);
      plusIcon.classList.remove(DISABLED_SELECTOR);
      unitPlus.classList.remove(DISABLED_IMG_SELECTOR);
      unitPlusDisable.classList.add(DISABLED_IMG_SELECTOR);
      if (orderValue === -1) {
        return minQuantityforInfluenza;
      }
    }
    return orderValue;
  }

  private static handleMaxOrderValue(
    orderValue: number,
    minusIcon: HTMLElement,
    unitMinus: HTMLElement,
    unitMinusDisable: HTMLElement,
    plusIcon: HTMLElement,
    unitPlus: HTMLElement,
    unitPlusDisable: HTMLElement
  ): number {
    if (orderValue >= influenzaMaxQuantity) {
      orderValue = influenzaMaxQuantity;
      minusIcon.classList.remove(DISABLED_SELECTOR);
      unitMinus.classList.remove(DISABLED_IMG_SELECTOR);
      unitMinusDisable.classList.add(DISABLED_IMG_SELECTOR);
      plusIcon.classList.add(DISABLED_SELECTOR);
      unitPlus.classList.add(DISABLED_IMG_SELECTOR);
      unitPlusDisable.classList.remove(DISABLED_IMG_SELECTOR);
    }
    return orderValue;
  }

  private static handleNormalOrderValue(
    orderValue: number,
    minusIcon: HTMLElement,
    plusIcon: HTMLElement,
    unitMinus: HTMLElement,
    unitPlus: HTMLElement,
    unitMinusDisable: HTMLElement,
    unitPlusDisable: HTMLElement
  ) {
    if (
      orderValue > minQuantityforInfluenza &&
      orderValue < influenzaMaxQuantity
    ) {
      minusIcon.classList.remove(DISABLED_SELECTOR);
      plusIcon.classList.remove(DISABLED_SELECTOR);
      unitPlus.classList.remove(DISABLED_IMG_SELECTOR);
      unitMinus.classList.remove(DISABLED_IMG_SELECTOR);
      unitPlusDisable.classList.add(DISABLED_IMG_SELECTOR);
      unitMinusDisable.classList.add(DISABLED_IMG_SELECTOR);
    }
  }

  private static updateDoseDisplayForInfluenza(
    inputElement: HTMLInputElement,
    noOfDoses: HTMLElement,
    orderValue: number,
    quantityOfUnits: number
  ) {
    if (inputElement.value !== '') {
      inputElement.value = orderValue?.toString();
      noOfDoses.innerHTML = `${orderValue * quantityOfUnits}  Dosen`;
    } else {
      noOfDoses.innerHTML = `${quantityOfUnits}  Dosen`;
    }
    if (orderValue === 0) {
      noOfDoses.innerHTML = '';
    }
  }
  private static handleInvalidInput(
    orderValue: number,
    elements: {
      inputElement: HTMLInputElement;
      plusIcon: HTMLElement;
      unitPlus: HTMLElement;
      unitPlusDisable: HTMLElement;
      minusIcon: HTMLElement;
      unitMinus: HTMLElement;
      unitMinusDisable: HTMLElement;
      noOfDoses: HTMLElement;
    },
    quantityOfUnits: number
  ) {
    const {
      inputElement,
      plusIcon,
      unitPlus,
      unitPlusDisable,
      minusIcon,
      unitMinus,
      unitMinusDisable,
      noOfDoses,
    } = elements;

    if (orderValue > influenzaMaxQuantity) {
      orderValue = influenzaMaxQuantity;
      inputElement.value = influenzaMaxQuantity.toString();
      plusIcon.classList.add(DISABLED_SELECTOR);
      unitPlus.classList.add(DISABLED_IMG_SELECTOR);
      unitPlusDisable.classList.remove(DISABLED_IMG_SELECTOR);
      noOfDoses.innerHTML = `${orderValue * quantityOfUnits}  Dosen`;
    } else {
      if (noOfDoses) {
        noOfDoses.innerHTML = `${quantityOfUnits}  Dosen`;
      }

      if (!orderValue) {
        minusIcon?.classList.add(DISABLED_SELECTOR);
        unitMinus?.classList.add(DISABLED_IMG_SELECTOR);
        unitMinusDisable?.classList.remove(DISABLED_IMG_SELECTOR);
        plusIcon?.classList.remove(DISABLED_SELECTOR);
        unitPlus?.classList.remove(DISABLED_IMG_SELECTOR);
        unitPlusDisable?.classList.add(DISABLED_IMG_SELECTOR);
      }
    }
  }

  static getMaximumQuantity(priceChannel: PriceChannel): number {
    return priceChannel === PriceChannel.PRIVATE
      ? maximumQuantityPrivate
      : maximumQuantityPublic;
  }

  static channelPrivateAndNumberUnitsPerCartonMoreThanOne(
    numberOfUnitsPerCarton: number,
    selectedChannel: PriceChannel
  ): boolean {
    return numberOfUnitsPerCarton && selectedChannel === PriceChannel.PRIVATE;
  }

  static checkIfQuantityIsCorrect(
    conditionsForCartonsLogicMeet: boolean,
    entries: CartItem,
    globalMessage: GlobalMessageService,
    errorMsgTimeout = 5000
  ): CartItem {
    if (
      conditionsForCartonsLogicMeet &&
      entries.quantity % entries.product.numberOfUnitsPerCarton
    ) {
      const properQuantity =
        Math.ceil(entries.quantity / entries.product.numberOfUnitsPerCarton) *
        entries.product.numberOfUnitsPerCarton;

      globalMessage.add(
        { key: 'httpHandlers.cartWrongQuantityError' },
        GlobalMessageType.MSG_TYPE_ERROR,
        errorMsgTimeout
      );

      return { ...entries, quantity: properQuantity };
    }

    return entries;
  }
}
